module.exports = __webpack_public_path__ + "img/logo.4ff674b7.png";